<template>
  <div>

    <!-- //FILTRO -->
    <div class="row" v-if="!list">
      <div class="col-md-12" style="flex-wrap: wrap; margin-bottom: 20px">
        <div class="text-right">
          <btn-rounded class="text-right" :label="filter ? 'LIMPAR' : 'FILTRO'" event="showFilter"
            :active-color="filter ? 'danger' : 'primary'" />
        </div>

      </div>

      <div v-if="filter">
        <div class="row" style="padding: 20px" text-center>

          <div class="col-md-3">
            <fg-input type="date" label="Data de criação Inicial" :max="filterOptions.intervalEnd"
              v-model="filterOptions.intervalStart" />
          </div>

          <div class="col-md-3">
            <fg-input type="date" label="Data de criação Final" :min="filterOptions.intervalStart"
              v-model="filterOptions.intervalEnd" />
          </div>
          <div class="col-md-3">
            <fg-select :options="attendedList" v-model="filterOptions.isAttended" :selected="filterOptions.isAttended"
              label="Status suporte" />
          </div>
        </div>

        <div class="row" style="padding: 20px" text-center>
          <div class="col-md-6">
            <fg-input type="text" label="Busca" placeholder="Solicitação, Solucionador, parte da mensagem..." v-model="filterOptions.term" />
          </div>
        </div>

        <div class="row" style="margin-bottom: 20px">
          <div class="col-md-12" style="flex-wrap: wrap;">
            <div class="text-right">
              <btn-rounded class="text-right" label="FILTRAR" event="activeFilter" active-color="success" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FILTRO// -->
    <v-dialog/>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <component-table eventName="DoneSupport" :title="table.title" :sub-title="table.subTitle"
            :data="list || supportList" :columns="table.columns" :headers="table.headers" :control="table.control"
            :buttons="table.buttons" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import moment from 'moment';
import VModal from 'vue-js-modal'
import Vue from 'vue'

Vue.use(VModal, { dialog: true })

const headers = ["Data", "Usuário", "E-Mail", "Mensagem", "Solucionador", "Última atualização","Status"];
const tableColumns = [
  {
    columnName: "createdAt",
    logic: function (data, columnData) {
      if (!data) {
        return ''
      }
      return moment.utc(data).utcOffset(-180).format('D/M/YYYY H:mm:ss');
    }
  },
  "User.nickname",
  "User.email",
  "msg",
  "Solver.nickname",

  {
    columnName: "updatedAt",
    logic: function (data, columnData) {
      if (!data) {
        return ''
      }
      return moment.utc(data).utcOffset(-180).format('D/M/YYYY H:mm:ss');
    }
  },
  {
    columnName: "isAttended",
    logic: function (data) {
      let className = 'text-danger';
      let val = 'Pendente';
      if (data) {
        className = 'text-success';
        val = 'Resolvido';
      }
      let prefix = `<span class="${className}" style="font-size:large">&bullet;</span>`;

      return `${prefix} ${val}`
    }
  },
];

export default {
  components: {
    ComponentTable
  },

  props: {
    list: {
      type: Array,
      default: () => {
        return null;
      }
    }
  },

  computed: {
    ...mapState({
      supportList: ({ support }) => support.list
    }),
    ...mapGetters({
      sidebarFlag: 'sidebarFlag'
    })
  },

  methods: {
    ...mapActions(["getSupportList", "updateSupport"]),

    setPage: function (page) {
      this.page = page;
    },

    cleanFilter() {
      for (let idx in this.filterOptions) {
        this.filterOptions[idx] = undefined;
      }
      // this.filterOptions.intervalStart = moment().startOf('month').format('YYYY-MM-DD');
      // this.filterOptions.intervalEnd = moment().endOf('month').format('YYYY-MM-DD');
      this.initData();
    },

    initData() {
      if (!this.list) {
        return this.getSupportList(this.filterOptions);
      }

      return Promise.resolve({

      })
    }
  },

  created() {
    this.cleanFilter();


    this.$on("showFilter", () => {
      if (this.filter) this.cleanFilter();
      this.filter = !this.filter;
    });
    this.$on("activeFilter", () => {
      if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
        return this.$notify({
          group: "foo",
          title: "Busca invalida",
          text: "Minímo de 3 caracteres",
          position: "top center",
          type: "error",
        });
      }
      this.initData();
      // this.filter = !this.filter;
    });

    this.$on("DoneSupport", item => {
      if (item.isAttended === true) {
                return null
       }

      this.$modal.show('dialog', {
        title: 'Atualizar chamado',
        text: 'Tem certeza que deseja confirmar a conclusão do suporte "' + item.msg + '?"',
        buttons: [
          {
            title: 'Sim',
            handler: () => {

              item.isAttended = true

                this.updateSupport(item)
                  .then(res => {
                    this.$notify({
                      group: "foo",
                      title: "Criação.",
                      text: "Chamado concluída",
                      position: "top center",
                      type: "success"
                    });
                    this.data = {};
                    this.$modal.hide('dialog')
                    this.initData();
                  })
                  .catch(res => {});
            }
          },
          {
            title: 'Não',       // Button title
            handler: () => {

              this.$modal.hide('dialog')
            } // Button click handler
          }

        ]
      })
    
    });

  },

  data() {
    return {
      page: 1,
      table: {
        title: "Suportes",
        subTitle: "Lista de suporte cadastrados",
        headers: [...headers],
        columns: [...tableColumns],
        //control: [...control],
        //buttons: [...buttons],
      },
      filter: false,
      filterOptions: {
        term: undefined,
        intervalStart: undefined,
        intervalEnd: undefined,
      },

      attendedList: [
        {
          value: true,
          name: "Resolvido"
        },
        {
          value: false,
          name: "Pendente"
        }
      ],

    };
  },

};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Support/SupportList.vue